'use client'

import { toaster } from './toaster'

type LegacyToastOptions = {
  status?: 'success' | 'error' | 'warning' | 'info' | 'loading'
  type?: 'success' | 'error' | 'warning' | 'info' | 'loading'
  title?: any
  description?: any
  duration?: number
  id?: string
  isClosable?: boolean
  closable?: boolean
  [key: string]: any
}

type LegacyToast = {
  (options: LegacyToastOptions): string
  close: (id?: string) => void
  closeAll: () => void
  isActive: (id: string) => boolean
  update: (id: string, options: LegacyToastOptions) => void
}

const normalizeToastOptions = (options: LegacyToastOptions = {}) => {
  const { status, isClosable, ...rest } = options

  return {
    ...rest,
    type: rest.type ?? status,
    closable: rest.closable ?? isClosable,
  }
}

export function useToast(): LegacyToast {
  const toast = ((options: LegacyToastOptions) =>
    toaster.create(normalizeToastOptions(options))) as LegacyToast

  toast.close = id => toaster.dismiss(id)
  toast.closeAll = () => toaster.dismiss()
  toast.isActive = id => toaster.isVisible(id)
  toast.update = (id, options) => toaster.update(id, normalizeToastOptions(options))

  return toast
}
